import React from 'react'

const CancelledTab = () => {
  return (
    <div>CancelledTab</div>
  )
}

export default CancelledTab